import React from "react";
import { RootStack } from "src/navigation/RootNavigation";
import withSuspense from "src/navigation/withSuspense";
const Home = withSuspense(React.lazy(() => import('./screens/Home')));
const Notes = withSuspense(React.lazy(() => import('./screens/Notes')));
const NoteEditor = withSuspense(React.lazy(() => import('./screens/NoteEditor')));
const NoteTabHistory = withSuspense(React.lazy(() => import('./screens/NoteTabHistory')));
export const renderAdminStackRoutes = ({}) => {
    return (React.createElement(RootStack.Group, null,
        React.createElement(RootStack.Screen, { name: "Admin_Home", component: Home }),
        React.createElement(RootStack.Screen, { name: "Admin_Notes", component: Notes }),
        React.createElement(RootStack.Screen, { name: "Admin_NoteEditor", component: NoteEditor }),
        React.createElement(RootStack.Screen, { name: "Admin_NoteTabHistory", component: NoteTabHistory })));
};
